module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/common/icon_train-a8fb1e7e0c29fcfc2da1cb5a5b8e61fa.svg";